module.exports = __webpack_public_path__ + "static/magda_stepien@1x-86541b7115f92b48b7eb9453d3cbf8d5.jpg";